import {
  CContainer,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
} from "@coreui/react";
import StoreExchangeDetail from "./StoreExchangeDetail";
import StoreExchange from "../../models/store-exchange";

interface StoreExchangeDetailModalProps {
  show: boolean;
  storeExchange?: StoreExchange;
  canRevert?: boolean;
  onCancel: () => void | Promise<void>;
  onReverted?: () => void | Promise<void>;
}

const StoreExchangeDetailModal: React.FC<StoreExchangeDetailModalProps> = ({
  show,
  storeExchange,
  canRevert,
  onCancel,
  onReverted,
}) => {
  const modalTitle = storeExchange?.id
    ? `Detalle de Cambio #${storeExchange.id}`
    : `Detalle de Cambio`;

  return (
    <CModal show={show} onClose={onCancel} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>{modalTitle}</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          <StoreExchangeDetail
            storeExchange={storeExchange}
            canRevert={canRevert}
            onCancel={onCancel}
            onReverted={onReverted}
          ></StoreExchangeDetail>
        </CContainer>
      </CModalBody>
    </CModal>
  );
};

export default StoreExchangeDetailModal;
